<script>
  import { navigate } from 'svelte-routing';
  import { _ } from 'svelte-i18n';

  import { answers } from './../libs/stores.js';
  
  import Footer from "./../components/Footer.svelte";

  export let config;

  let current_page = 0;
  let answer = null;

  function handle_next(ev) {
    $answers.aim = answer;
    navigate("/q/" + config);

    window.scrollTo(0, 0); // go back to top
  }

</script>

<div>

  <!-- navbar -->
  <div class="navbar bg-neutral-content flex-col sm:flex-row">
    <div class="flex-1">
      <h1 class="text-2xl font-bold ml-4">ONAT4All
          <small class="opacity-30"> 
              S<span class="hidden md:inline">elf</span><!--
              --><span class="hidden md:inline">-</span><!--
              -->A<span class="hidden md:inline">assessment</span>
              T<span class="hidden md:inline">ool</span>
          </small>
      </h1>
    </div>
  </div>
  
  <!-- content -->
  <div class="container px-4 sm:px-0 pt-6 pb-16 sm:mx-auto prose">

    <h2 class="text-center mt-8"> {$_('profiling.select_aim')}: </h2>

    <!-- question -->
    <div class="ml-4 sm:ml-6">

        <div class="form-control">
          <label class="label cursor-pointer justify-start">
            <input type="radio" name="l1" class="radio checked:bg-primary" value="1" bind:group={answer} />
            <span class="label-text ml-4 text-justify"> <b> {$_('profiling.level_1')} </b>: {$_('profiling.level_1_desc')} </span>
          </label>
        </div>

        <div class="form-control">
          <label class="label cursor-pointer justify-start">
            <input type="radio" name="l2" class="radio checked:bg-primary" value="2" bind:group={answer} />
            <span class="label-text ml-4 text-justify"> <b> {$_('profiling.level_2')} </b>: {$_('profiling.level_2_desc')} </span>
          </label>
        </div>

        <div class="form-control">
          <label class="label cursor-pointer justify-start">
            <input type="radio" name="l3" class="radio checked:bg-primary" value="3" bind:group={answer} />
            <span class="label-text ml-4 text-justify"> <b> {$_('profiling.level_3')} </b>: {$_('profiling.level_3_desc')} </span>
          </label>
        </div>

        <div class="form-control">
          <label class="label cursor-pointer justify-start">
            <input type="radio" name="l4" class="radio checked:bg-primary" value="4" bind:group={answer} />
            <span class="label-text ml-4 text-justify"> <b> {$_('profiling.level_4')} </b>: {$_('profiling.level_4_desc')} </span>
          </label>
        </div>
    </div>

  </div>

  <!-- buttons -->
  <div class="w-5/6 lg:w-1/3 mx-auto mt-4 mb-8 flex justify-between flex-row-reverse">
    <!--! Font Awesome Pro 6.1.2 by @fontawesome - https://fontawesome.com
    License - https://fontawesome.com/license (Commercial License)
    Copyright 2022 Fonticons, Inc. -->
  
    <button class="btn btn-secondary gap-2" disabled={answer == null} on:click={handle_next}>
      Next <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 256 512" fill="currentColor"><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"/></svg>
    </button>
    
  </div>

  <Footer/>

</div>

